PES = PES || {}
PES.PasswordTooltipValidation = function () {

    function init(targetId) {
        let passwordInput = document.getElementById(targetId).value;

        function validateInputString(rawPassword) {
            let password = rawPassword.toLowerCase();
            let validityCriteria = {
                lengthRespected: password.length >= 8 && password.length <= 64,
                seriesRespected: false,
                repeatRespected: false
            };
            let lastChar = password[0];
            let foundAscendingSeries = false;
            let foundDesscendingSeries = false;

            for (let i = 1; i < password.length; i++) {
                if (password[i] !== lastChar) {
                    validityCriteria.repeatRespected = true;
                }
                let charCodeDiff = password.charCodeAt(i) - lastChar.charCodeAt(0);
                foundAscendingSeries = foundAscendingSeries || charCodeDiff === 1;
                foundDesscendingSeries = foundDesscendingSeries || charCodeDiff === -1;

                if (Math.abs(charCodeDiff) !== 1 || (foundAscendingSeries && foundDesscendingSeries)) {
                    validityCriteria.seriesRespected = true;
                }
                lastChar = password[i];
            }
            return validityCriteria;
        }


        function updateTooltipValidation() {
            let charLength = document.querySelector(".criterion.checkCharLength span[data-purpose='status-indicator']");
            let charRepeat = document.querySelector(".criterion.checkRepeat span[data-purpose='status-indicator']");
            let charSeries = document.querySelector(".criterion.checkSeries span[data-purpose='status-indicator']");

            let passwordStatus = validateInputString(passwordInput);

            if (passwordStatus.lengthRespected) {
                charLength.setAttribute("data-status", "ok");
            } else {
                charLength.removeAttribute("data-status");
            }

            if (passwordStatus.repeatRespected) {
                charRepeat.setAttribute("data-status", "ok");
            } else {
                charRepeat.removeAttribute("data-status");
            }

            if (passwordStatus.seriesRespected) {
                charSeries.setAttribute("data-status", "ok");
            } else {
                charSeries.removeAttribute("data-status");
            }

            removeAnimationClass();
            if (!passwordStatus.lengthRespected && !passwordStatus.repeatRespected && !passwordStatus.seriesRespected){
                removeAnimationClass(); 
            } else if (!passwordStatus.lengthRespected || !passwordStatus.repeatRespected || !passwordStatus.seriesRespected) {
                addAnimationClass();
            } else {
                removeAnimationClass();
            };
        };
        function addAnimationClass() {
            document.querySelector(".password-requirements-container").classList.add("shake-container");
        };

        function removeAnimationClass() {
            document.querySelector(".password-requirements-container").classList.remove("shake-container");
        };

        function checkInputValueLength(passwordInput) {

            if (passwordInput.length < 1) {
                document.querySelector(".strength-notifier").classList.add("empty-field");
            } else if (passwordInput.length > 0) {
                document.querySelector(".strength-notifier").classList.add("Weakest");
                document.querySelector(".strength-notifier").classList.remove("empty-field");
            } 
        }

        (function () {
            validateInputString(passwordInput);
            checkInputValueLength(passwordInput);
            updateTooltipValidation();
        })();
    }    
    return {
        init: init
    }
    
}